import React, { useEffect, useState } from "react";
import styles from "./MarketplaceActivity.module.sass";
import cn from "classnames";
import Row from "./row";
import Loader from "../../components/Loader";
import Card from "../../components/Card";
import { UseApi } from "../../hooks/use-api";
import { GetActivityAll } from "../../Services/lib/nft";
import Dropdown from "../../components/Dropdown";
import Empthy from "../../components/Empty";
import NFTModal from "../../components/NFTModal";
import { UseDisclosure } from "../../hooks/use-disclosure";
import communityMarketplace from "../../i11/CommunityMarketplace";
import { useUser } from "../../context";

const intervals = ["Last 3 days", "Last 5 days", "Last 7 days", "last 14 days"];
const intervalVals = {
	"Last 3 days": 2,
	"Last 5 days": 4,
	"Last 7 days": 6,
	"last 14 days": 13,
};
const options = ["All", "Direct purchase", "Community market"];
const optionsVal = {
	All: undefined,
	"Direct purchase": "PRIMARY",
	"Community market": "SECONDARY",
};

const MarketplaceActivity = () => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [product, setProduct] = useState();
	const [sorting, setSorting] = useState(intervals[2]);
	const [option, setOption] = useState(options[0]);
	const [{ data, isLoading }, fetch] = UseApi({
		service: GetActivityAll,
	});

	const close = () => {
		setProduct();
		onClose();
	};

	const open = (data_) => {
		setProduct(data_);
		onOpen();
	};

	useEffect(() => {
		fetch({
			range: intervalVals[sorting],
			market: "SECONDARY",
		});
	}, [option, sorting]);
	return (
		<Card
			title={communityMarketplace[locale].activity}
			classTitle="title-green"
			head={
				<>
					<Dropdown
						className={styles.dropdown}
						classDropdownHead={styles.dropdownHead}
						value={sorting}
						setValue={setSorting}
						dictionary={communityMarketplace[locale].dictionary}
						options={intervals}
						small
					/>
					{/* <Dropdown
						className={styles.dropdown1}
						classDropdownHead={styles.dropdownHead}
						value={option}
						setValue={setOption}
						options={options}
						small
					/> */}
				</>
			}
		>
			<div className={styles.wrapper}>
				<div className={styles.table}>
					<div className={styles.row}>
						<div className={styles.col}></div>
						<div className={cn(styles.wide, styles.col)}>
							{communityMarketplace[locale].from}
						</div>
						<div className={cn(styles.wide, styles.col)}>
							{communityMarketplace[locale].to}
						</div>
						<div className={styles.col}>
							{communityMarketplace[locale].price}
						</div>
						<div className={styles.col}>
							{communityMarketplace[locale].date}
						</div>
					</div>
					{isLoading ? (
						<div className={styles.loaderWrap}>
							<Loader />
						</div>
					) : data?.length === 0 ? (
						<Empthy />
					) : (
						data?.map((e) => <Row open={open} key={e._id} data={e} />)
					)}
				</div>
				{/* <div className={styles.foot}>
					<button className={cn("button-stroke button-small", styles.button)}>
						<Loader className={styles.loader} />
						<span>Load more</span>
					</button>
				</div> */}
			</div>
			<NFTModal visible={isOpen && product} onClose={close} data={product} />
			{/* <ProductModal
				owner
				visible={isOpen && product}
				onClose={close}
				data={product}
			/> */}
		</Card>
	);
};

export default MarketplaceActivity;
